import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from '#src/app/shared/contexts/asyncData';

import { getNewsAndGuidesListPageData } from './api';
import type { NewsAndGuidesListPageDataErrorCode } from './types';

/** @knip-ignore */
export const {
	Context: NewsAndGuidesListPageDataContext,
	Provider: NewsAndGuidesListPageDataContextProvider,
	useContext: useNewsAndGuidesListPageData,
	useAsyncData: useNewsAndGuidesListPageDataFromApi,
	prefetchAsyncData: prefetchNewsAndGuidesListPageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'NewsAndGuidesListPageDataContext',
	dataProperty: 'pageData',
	getData: getNewsAndGuidesListPageData,
	hookDeps: ({ countryCode, locale, guides, disableMode }) => [countryCode, locale, guides, disableMode],
	getUniqueId: ({ countryCode, locale, guides, disableMode }) => [countryCode, locale, guides, disableMode].join('|'),
	errorHandler: pageDataErrorHandler<NewsAndGuidesListPageDataErrorCode>(),
});
